module.exports = __webpack_public_path__ + "img/reg-compliance-active.0a3ff92f.svg";